import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

const BasicLayout = ({ children }: PropsWithChildren<any>) => {
  return <Box marginTop={3} paddingBottom={3}>{children}</Box>;
};

export default BasicLayout;
